import React, { useContext, useEffect, useRef, useState } from "react";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import { useErrorNotification } from "@common/components/Notification";
import { getMeetingDialInfo } from "@services/meetings";
import { Paper, useTheme } from "@mui/material";
import { WithGrow } from "@common/components/WithGrow";
import DialinButton from "./DialinButton";
import { colorCorrectHTML } from "../common/color";
import { replaceTextNodeLinesWithHr } from "./utils";

const Dialin = () => {
  const context = useContext(RoomsRealtimeContext);
  const meeting = { ...context.detail?.meeting };
  const dispatchError = useErrorNotification();
  const ref = useRef<HTMLDivElement>(null);
  const [dialInfo, setDialInfo] = useState<string>();
  const theme = useTheme();

  const fetch = async (id: typeof meeting.id) => {
    try {
      const dialInfo = await getMeetingDialInfo(meeting.id);
      setDialInfo(dialInfo.dialInfo);
    } catch (e) {
      dispatchError(e);
    }
  };

  useEffect(() => {
    if (meeting?.id !== undefined) fetch(meeting.id);
  }, [context.detail?.meeting?.id]);

  useEffect(() => {
    if (ref.current && dialInfo) {
      const dialInfoWithReplacedLines = replaceTextNodeLinesWithHr(dialInfo);

      ref.current.innerHTML = colorCorrectHTML(
        dialInfoWithReplacedLines,
        theme.palette.mode
      );
    }
  }, [ref.current, dialInfo, theme.palette.mode]);

  return (
    <WithGrow
      direction="column-reverse"
      fixed={<DialinButton />}
      fixedSx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
      }}
    >
      <Paper
        ref={ref}
        elevation={0}
        sx={(theme) => ({
          maxHeight: "100%",
          minHeight: "100%",
          overflowY: "scroll",
          wordBreak: "break-word",
          "& a": {
            color: theme.palette.primary.main,
          },
        })}
      />
    </WithGrow>
  );
};

export default Dialin;
